var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {useCallback, useEffect} from "react";
import {useHistory} from "react-router-dom";
import momentTimezone from "moment-timezone";
import {callApi, getRefreshToken, setApiRefreshToken, setApiToken} from "../api";
import QueryString from "query-string";
import {customLocalStorage, customSessionStorage} from "../customStorage";
import {useCustomFieldsContext} from "../customFields";
import {RoutePath} from "../../components/routes";
import {DEFAULT_COUNTRY} from "../../constants";
import {cleanLocalStorageReferredData} from "../../utils/helper";
import {useIntegrationContext} from "../integration";
import {getCallEmailText, profileHeaderToken} from "../utils";
export default function useActions(setLoading, setProviderError, setToken, setUser, setCallEmail, user, token, callEmail) {
  const history = useHistory();
  const {actions: customFieldsActions} = useCustomFieldsContext();
  const {actions: integrationActions} = useIntegrationContext();
  useEffect(() => {
    if (token && !callEmail) {
      getCallEmail();
    }
  }, [token, callEmail]);
  const processRedirect = (newUser, redirect, skipRedirect) => {
    if (customLocalStorage.getItem("referrer") || customLocalStorage.getItem("wiseInviteCode")) {
      history.push(RoutePath.Onboarding);
    } else {
      if (redirect) {
        history.push(redirect);
        customSessionStorage.removeItem("redirectUrl");
      } else if (!skipRedirect) {
        history.push(newUser.isExpert ? "/profile" : "/experts");
      }
      customLocalStorage.removeItem("redirectUrl");
    }
    cleanLocalStorageReferredData();
  };
  const fetchLogin = (body, skipRedirect, redirectUrl) => __async(this, null, function* () {
    setLoading(true);
    setProviderError(null);
    const redirect = redirectUrl || customSessionStorage.getItem("redirectUrl");
    const loginResponse = yield callApi("auth/login", {
      method: "POST",
      body,
      query: {
        referrer: customLocalStorage.getItem("referrer"),
        inviteCode: customLocalStorage.getItem("wiseInviteCode")
      }
    });
    setLoading(false);
    const {data} = loginResponse.payload;
    if (loginResponse.ok) {
      const newUser = __spreadProps(__spreadValues({}, data.user), {
        phone_country_id: String(data.user.phone_country_id)
      });
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setApiToken(data.token);
      setApiRefreshToken(data.refreshToken);
      setToken(data.token);
      setUser(newUser);
      processRedirect(newUser, redirect, skipRedirect);
    } else {
      setApiToken();
      setApiRefreshToken();
      setProviderError(data.message || "Cannot login!");
    }
  });
  const fetchRefreshUser = () => __async(this, null, function* () {
    setLoading(true);
    setProviderError(null);
    const refreshToken = getRefreshToken();
    if (refreshToken) {
      const response = yield callApi("auth/refresh-user", {
        method: "POST",
        body: {refreshToken}
      });
      setLoading(false);
      const {data} = response.payload;
      if (response.ok) {
        const newUser = __spreadProps(__spreadValues({}, data.user), {
          phone_country_id: String(data.user.phone_country_id)
        });
        customLocalStorage.setItem("user", JSON.stringify(newUser));
        setApiToken(data.token);
        setApiRefreshToken(data.refreshToken);
        setToken(data.token);
        setUser(newUser);
      } else {
        setApiToken();
        setApiRefreshToken();
        setProviderError(data.message || "Cannot refresh user data!");
      }
    } else {
      setLoading(false);
    }
    const query = QueryString.parse(history.location.search, {
      arrayFormat: "comma",
      parseNumbers: true
    });
    const historySearch = QueryString.stringify(__spreadProps(__spreadValues({}, query), {
      refreshUser: void 0
    }), {arrayFormat: "comma"});
    history.replace({search: historySearch});
  });
  const fetchGoogleLogin = (tokenId, skipRedirect, redirectUrl) => __async(this, null, function* () {
    setLoading(true);
    setProviderError(null);
    const redirect = redirectUrl || customSessionStorage.getItem("redirectUrl");
    const loginResponse = yield callApi("auth/login/google", {
      method: "POST",
      body: {tokenId},
      query: {
        referrer: customLocalStorage.getItem("referrer"),
        inviteCode: customLocalStorage.getItem("wiseInviteCode")
      }
    });
    setLoading(false);
    const {data} = loginResponse.payload;
    if (loginResponse.ok) {
      const newUser = __spreadProps(__spreadValues({}, data.user), {
        phone_country_id: String(data.user.phone_country_id)
      });
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setToken(data.token);
      setApiToken(data.token);
      setApiRefreshToken(data.refreshToken);
      setUser(newUser);
      processRedirect(newUser, redirect, skipRedirect);
    } else {
      setApiToken();
      setApiRefreshToken();
      setProviderError(data.message || "Cannot login!");
    }
  });
  const fetchLinkedinLogin = (tokenId, skipRedirect, redirectUrl) => __async(this, null, function* () {
    setLoading(true);
    setProviderError(null);
    const redirect = redirectUrl || customSessionStorage.getItem("redirectUrl") || customLocalStorage.getItem("redirectUrl");
    const loginResponse = yield callApi("auth/login/linkedin", {
      method: "POST",
      body: {tokenId},
      query: {
        referrer: customLocalStorage.getItem("referrer"),
        inviteCode: customLocalStorage.getItem("wiseInviteCode")
      }
    });
    setLoading(false);
    const {data} = loginResponse.payload;
    if (loginResponse.ok) {
      const newUser = __spreadProps(__spreadValues({}, data.user), {
        phone_country_id: String(data.user.phone_country_id)
      });
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setToken(data.token);
      setApiToken(data.token);
      setApiRefreshToken(data.refreshToken);
      setUser(newUser);
      processRedirect(newUser, redirect, skipRedirect);
    } else {
      setApiToken();
      setApiRefreshToken();
      setProviderError(data.message || "Cannot login!");
    }
  });
  const fetchRegister = (body, skipRedirect, redirectUrl) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const redirect = redirectUrl || customSessionStorage.getItem("redirectUrl");
    if (redirect) {
      customSessionStorage.setItem("redirectUrl", redirect);
    }
    const country = body.phone_country_code || DEFAULT_COUNTRY.iso;
    const registerResponse = yield callApi("auth/register", {
      method: "POST",
      body: __spreadProps(__spreadValues({}, body), {
        country,
        timezone: momentTimezone.tz.guess()
      }),
      query: {
        referrer: customLocalStorage.getItem("referrer") || void 0,
        inviteCode: customLocalStorage.getItem("wiseInviteCode") || void 0
      }
    });
    setLoading(false);
    const {data} = registerResponse.payload;
    if (registerResponse.ok) {
      const newUser = __spreadProps(__spreadValues({}, data.user), {
        phone_country_id: String(data.user.phone_country_id)
      });
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setToken(data.token);
      setApiToken(data.token);
      setApiRefreshToken(data.refreshToken);
      setUser(newUser);
      cleanLocalStorageReferredData();
      history.push(RoutePath.Onboarding);
    } else {
      setApiToken();
      setApiRefreshToken();
      setProviderError(data.message || "Cannot register!");
    }
  });
  const fetchGoogleRegister = (tokenId, skipRedirect, redirectUrl) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const redirect = redirectUrl || customSessionStorage.getItem("redirectUrl");
    if (redirect) {
      customSessionStorage.setItem("redirectUrl", redirect);
    }
    const registerResponse = yield callApi("auth/register/google", {
      method: "POST",
      body: {tokenId},
      query: {
        referrer: customLocalStorage.getItem("referrer") || void 0,
        inviteCode: customLocalStorage.getItem("wiseInviteCode") || void 0
      }
    });
    setLoading(false);
    const {data} = registerResponse.payload;
    if (registerResponse.ok) {
      const newUser = __spreadProps(__spreadValues({}, data.user), {
        phone_country_id: String(data.user.phone_country_id)
      });
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setToken(data.token);
      setApiToken(data.token);
      setApiRefreshToken(data.refreshToken);
      setUser(newUser);
      cleanLocalStorageReferredData();
      history.push(RoutePath.Onboarding);
    } else {
      setApiToken();
      setApiRefreshToken();
      setProviderError(data.message || "Cannot register!");
    }
  });
  const fetchLinkedinRegister = (tokenId, skipRedirect, redirectUrl) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const redirect = redirectUrl || customSessionStorage.getItem("redirectUrl") || customLocalStorage.getItem("redirectUrl");
    if (redirect) {
      customLocalStorage.removeItem("redirectUrl");
      customSessionStorage.setItem("redirectUrl", redirect);
    }
    const registerResponse = yield callApi("auth/register/linkedin", {
      method: "POST",
      body: {tokenId},
      query: {
        referrer: customLocalStorage.getItem("referrer") || void 0,
        inviteCode: customLocalStorage.getItem("wiseInviteCode") || void 0
      }
    });
    setLoading(false);
    const {data} = registerResponse.payload;
    if (registerResponse.ok) {
      const newUser = __spreadProps(__spreadValues({}, data.user), {
        phone_country_id: String(data.user.phone_country_id)
      });
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setToken(data.token);
      setApiToken(data.token);
      setApiRefreshToken(data.refreshToken);
      setUser(newUser);
      cleanLocalStorageReferredData();
      history.push(RoutePath.Onboarding);
    } else {
      setApiToken();
      setApiRefreshToken();
      setProviderError(data.message || "Cannot register!");
    }
  });
  const fetchUpdateAccount = (body) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const registerResponse = yield callApi("account", {
      method: "PUT",
      body
    });
    setLoading(false);
    const {data} = registerResponse.payload;
    const email = user.email;
    if (registerResponse.ok) {
      const newUser = __spreadProps(__spreadValues(__spreadValues({}, user), data), {
        phone_country_id: data.phone_country_id ? String(data.phone_country_id) : String(user.phone_country_id) || "1"
      });
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setUser(newUser);
      if (email !== newUser.email)
        logout();
    } else {
      setProviderError(data.message || "Cannot Update Account!");
      if (registerResponse.status === 401) {
        logout();
      }
    }
  });
  const fetchUpdateAdditionalInfo = (body) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const additionalInfoResponse = yield callApi("account/additional-info", {
      method: "PUT",
      body
    });
    setLoading(false);
    const {data} = additionalInfoResponse.payload;
    if (additionalInfoResponse.ok) {
      const newUser = __spreadValues(__spreadValues({}, user), data.user);
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setUser(newUser);
      customFieldsActions.overwriteCustomFields(data.custom);
    } else {
      setProviderError(data.message || "Cannot Update Account!");
      if (additionalInfoResponse.status === 401) {
        logout();
      }
    }
  });
  const fetchUpdateEEO = (body) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const additionalInfoResponse = yield callApi("account/eeo", {
      method: "PUT",
      body
    });
    setLoading(false);
    const {data} = additionalInfoResponse.payload;
    if (additionalInfoResponse.ok) {
      const newUser = __spreadValues(__spreadValues({}, user), data);
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setUser(newUser);
      return {ok: additionalInfoResponse.ok};
    } else {
      const error = data.message || "Cannot Update EEO fields!";
      setProviderError(error);
      return Promise.reject(error);
    }
  });
  const fetchUpdateOnboardingData = (body) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const onboardingDataResponse = yield callApi("account/onboarding", {
      method: "PUT",
      body
    });
    setLoading(false);
    const {data} = onboardingDataResponse.payload;
    if (onboardingDataResponse.ok) {
      const newUser = __spreadValues(__spreadValues({}, user), data);
      customLocalStorage.setItem("user", JSON.stringify(newUser));
      setUser(newUser);
      return {ok: onboardingDataResponse.ok};
    } else {
      const error = data.message || "Cannot Update Onboarding data!";
      setProviderError(error);
      return Promise.reject(error);
    }
  });
  const fetchCronofyFilled = (isFilled, token2) => __async(this, null, function* () {
    setProviderError(null);
    setLoading(true);
    const cronofyResponse = yield callApi("account/cronofy/filled", __spreadValues({
      method: "PUT",
      body: {isFilled}
    }, token2 ? {headers: profileHeaderToken(token2)} : {}));
    setLoading(false);
    const {data} = cronofyResponse.payload;
    if (cronofyResponse.ok) {
      if (!token2) {
        const newUser = __spreadProps(__spreadValues({}, user), {
          cronofy_filled: isFilled
        });
        customLocalStorage.setItem("user", JSON.stringify(newUser));
        setUser(newUser);
      }
      return {ok: cronofyResponse.ok};
    } else {
      const error = data.message || "Cannot Update Office Hours!";
      setProviderError(error);
      if (!token2 && cronofyResponse.status === 401) {
        logout();
      }
      return Promise.reject(error);
    }
  });
  const resetPassword = (email) => __async(this, null, function* () {
    setLoading(true);
    setProviderError(null);
    const resetResponse = yield callApi("auth/reset", {
      method: "POST",
      body: {email, return_url: window.location.href}
    });
    setLoading(false);
    return resetResponse;
  });
  const fetchGetCallEmail = () => __async(this, null, function* () {
    const getCallEmailResponse = yield callApi("account/call-email", {
      method: "GET"
    });
    const {data} = getCallEmailResponse.payload;
    if (getCallEmailResponse.ok) {
      setCallEmail(getCallEmailText(data.email));
    } else {
      setCallEmail("");
      setProviderError(data.message || "Cannot get call email!");
    }
  });
  const login = useCallback(fetchLogin, [history, setLoading, setProviderError, setToken, setUser]);
  const register = useCallback(fetchRegister, [history, setLoading, setProviderError, setToken, setUser]);
  const setError = useCallback((errorMessage) => {
    setProviderError(errorMessage || null);
  }, [setProviderError]);
  const getCallEmail = useCallback(fetchGetCallEmail, [user, setCallEmail]);
  const logout = useCallback((skipRedirect) => {
    customLocalStorage.removeItem("user");
    setApiToken();
    setApiRefreshToken();
    setToken(null);
    setUser(null);
    customFieldsActions.clearCustomFields();
    integrationActions.clearData();
    if (!skipRedirect) {
      history.push("/login");
    }
  }, [history, setToken, setUser]);
  const updateUserDataDeps = [logout, setLoading, setProviderError, setUser, user];
  const googleLogin = useCallback(fetchGoogleLogin, [history, setLoading, setProviderError, setToken, setUser]);
  const googleRegister = useCallback(fetchGoogleRegister, [history, setLoading, setProviderError, setToken, setUser]);
  const linkedinLogin = useCallback(fetchLinkedinLogin, [history, setLoading, setProviderError, setToken, setUser]);
  const linkedinRegister = useCallback(fetchLinkedinRegister, [
    history,
    setLoading,
    setProviderError,
    setToken,
    setUser
  ]);
  const updateAccount = useCallback(fetchUpdateAccount, updateUserDataDeps);
  const updateEEO = useCallback(fetchUpdateEEO, updateUserDataDeps);
  const updateOnboardingData = useCallback(fetchUpdateOnboardingData, updateUserDataDeps);
  const updateAdditionalInfo = useCallback(fetchUpdateAdditionalInfo, updateUserDataDeps);
  const setUserFields = useCallback((updatedUser) => {
    setUser(__spreadValues(__spreadValues({}, user), updatedUser));
  }, [setUser, user]);
  const cronofyFilled = useCallback(fetchCronofyFilled, [logout, setLoading, setProviderError, setUser, user]);
  const refreshUser = useCallback(fetchRefreshUser, []);
  return {
    login,
    register,
    googleLogin,
    googleRegister,
    linkedinLogin,
    linkedinRegister,
    updateAccount,
    setError,
    logout,
    setUserFields,
    cronofyFilled,
    resetPassword,
    refreshUser,
    updateAdditionalInfo,
    updateEEO,
    updateOnboardingData,
    getCallEmail
  };
}
